const ENVIRONMENTS = {
  dev: {
    apiBase: "https://clairedev.nl/api/v2",
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    customComBase: "https://comm.clairedev.nl/api/customcom/v1",
    customComBaseV2: "https://comm.clairedev.nl/api/customcom/v2",
    appointmentBase: "https://clairedev.nl/api/appointment/v1",
    deskComBase: "https://comm.clairedev.nl/api/desk/v1",
    authBase: "https://clairedev.nl/api/auth/v1",
    keylockerBase: "https://comm.clairedev.nl/api/keylocker/v1",
    kioskBase: "https://comm.clairedev.nl/api/kiosk/v1",
    systemBase: "https://clairedev.nl/api/system/v1",
    dealerBaseUrl: "https://clairedev.nl/api/dealer/v1",
  },
  local: {
    apiBase: "https://clairedev.nl/api/v2",
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    customComBase: "https://comm.clairedev.nl/api/customcom/v1",
    customComBaseV2: "https://comm.clairedev.nl/api/customcom/v2",
    appointmentBase: "https://clairedev.nl/api/appointment/v1",
    deskComBase: "https://comm.clairedev.nl/api/desk/v1",
    keylockerBase: "https://comm.clairedev.nl/api/keylockerv1",
    authBase: "https://clairedev.nl/api/auth/v1",
    kioskBase: "https://comm.clairedev.nl/api/kiosk/v1",
    systemBase: "https://clairedev.nl/api/system/v1",
  },
  localWithBackend: {
    apiBase: "http://localhost:8080/api/v2",
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    customComBase: "https://comm.clairedev.nl/api/customcom/v1",
    customComBaseV2: "https://comm.clairedev.nl/api/customcom/v2",
    appointmentBase: "https://clairedev.nl/api/appointment/v1",
    deskComBase: "https://comm.clairedev.nl/api/desk/v1",
    keylockerBase: "https://comm.clairedev.nl/api/keylocker/v1",
    authBase: "https://clairedev.nl/api/auth/v1",
    kioskBase: "https://comm.clairedev.nl/api/kiosk/v1",
    systemBase: "https://clairedev.nl/api/system/v1",
  },
  prod: {
    apiBase: "https://mycarcheck.pro/api/v2",
    clientID: "674901036874-hrv3lhqlkp3b0uh8lhoaj0hlmrqd37it.apps.googleusercontent.com",
    webSocketEndpoint: "wss://notifier.claireit.com",
    keylockerRelayIPAddress: "https://relaymodule.mycarcheck.pro",
    appointmentBase: "https://claireit.com/api/appointment/v1",
    customComBase: "https://mycarcheck.pro/api/customcom/v1",
    customComBaseV2: "https://mycarcheck.pro/api/customcom/v2",
    authBase: "https://claireit.com/api/auth/v1",
    deskComBase: "https://mycarcheck.pro/api/desk/v1",
    keylockerBase: "https://mycarcheck.pro/api/keylocker/v1",
    kioskBase: "https://mycarcheck.pro/api/kiosk/v1",
    systemBase: "https://claireit.com/api/system/v1",
    dealerBaseUrl: "https://claireit.com/api/dealer/v1",
  },
};

const ENV = ENVIRONMENTS[process.env.REACT_APP_ENV];

export default ENV;
